export type Value = number | null;
export type Metrics = Record<string, Value>;
export const validDate = (s: string) =>
  /^\d{4}-\d{2}-\d{2}$/.test(s) &&
  Number(s.slice(0, 4)) > 0 &&
  Number.isFinite(Date.parse(s + 'T00:00:00Z')) &&
  new Date(s + 'T00:00:00Z').toISOString().slice(0, 10) === s;
export const number = (v: Value, decimals = 0) =>
  v === null ? 'Unknown' : v.toLocaleString('en-AU', { maximumFractionDigits: decimals });
export const percent = (v: Value) => (v === null ? 'Unknown' : number(v * 100, 1) + '%');
export const growth = (a: Value, b: Value): Value =>
  a === null || b === null || b === 0 ? null : (a - b) / Math.abs(b);
export const ratio = (a: Value, b: Value): Value => (a === null || b === null || b === 0 ? null : a / b);
